import script from "./productVariation.vue?vue&type=script&lang=ts&setup=true"
export * from "./productVariation.vue?vue&type=script&lang=ts&setup=true"

import "./productVariation.vue?vue&type=style&index=0&id=47f36b11&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f36b11"]])

export default __exports__